import React, { useState } from 'react';
import {
  IconButton,
  Badge,
  Menu,
  Typography,
  Button,
  Dialog,
  DialogContent,
} from '@material-ui/core';
import NotificationsIcon from '@material-ui/icons/Notifications';
import CloseIcon from '@material-ui/icons/Close';
import { useHistory } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import useStore from '../../services/hooks/useStore';
import NotificacaoService from '../../services/NotificacaoService';
import styled from 'styled-components';
import { Notificacao } from '../../types/Notificacao';

const NotificacaoMenuItem = styled.div`
  padding: 16px;
  border-bottom: none;
  width: calc(100% - 16px);
  background-color: #FF9800;
  color: white;
  position: relative;
  cursor: pointer;
  margin: 8px;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
`;

const NotificacaoHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: #00A8E8;
  color: white;
  width: 100%;
`;

const NotificacaoTitle = styled(Typography)`
   font-size: 24px !important;
  font-weight: 500 !important;
  color: white;
  margin-bottom: -10px;
  
`;

const NotificacaoContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  padding-right: 24px;
  margin-top: -20px;
`;

const NotificacaoMessage = styled(Typography)`
  font-size: 14px;
  color: white;
  flex: 1;
`;

const NotificacaoIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  
  img {
    width: 100%;
    height: 100%;
    filter: brightness(0) invert(1);
  }
`;

const CloseButton = styled(IconButton)`
  position: absolute;
  top: 2px;
  right: 2px;
  color: white !important;
  padding: 4px !important;
  
  .MuiSvgIcon-root {
    font-size: 18px;
  }
`;

const HeaderCloseButton = styled(IconButton)`
  color: white !important;
  padding: 4px !important;
`;

const NotificacoesContainer = styled.div`
  max-height: 380px;
  overflow-y: auto;
  background-color: white;
  padding: 8px 0;
  margin-left:
  &::-webkit-scrollbar {
    width: 8px;
  }
  
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }
  
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

const MenuNotificacoesContainer = styled.div`
  background-color: white;
  padding: 8px 0;
`;

const MarcarLidasButton = styled(Button)`
  background-color: #4CAF50 !important;
  color: white !important;
  width: 100%;
  margin: 8px 0;
  position: relative;
  cursor: pointer;
  border-radius: 8px;
  &:hover {
    background-color: #45a049 !important;
  }
`;

const VerMaisButton = styled(Button)`
  background-color: #fff !important;
  border:2px solid #00A8E8 !important;
  margin: 10px 8px !important;
  width: calc(100% - 16px) !important;
  text-transform: none !important;
  border-radius: 8px !important;
  &:hover {
    color: #00A8E8
  }
`;

const NotificacoesMenu: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [modalOpen, setModalOpen] = useState(false);
  const store = useStore();
  const history = useHistory();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleModalOpen = () => {
    setModalOpen(true);
    handleClose();
  };

  const handleModalClose = () => {
    setModalOpen(false);
  };

  const getNotificationIcon = (tipo: string) => {
    switch (tipo) {
      case 'racao':
        return <img src="/images/arracoamento.svg" alt="Ração" />;
      case 'parcela':
        return <img src="/images/financeiro.svg" alt="Financeiro" />;
      case 'producao':
        return <img src="/images/producao.svg" alt="Produção" />;
      case 'venda':
        return <img src="/images/venda.svg" alt="Vendas" />;
      case 'qualidade_agua':
        return <img src="/images/qualidade_da_agua.svg" alt="Qualidade da Água" />;
      case 'propriedade':
        return <img src="/images/propriedade.svg" alt="Propriedade" />;
      default:
        return <NotificationsIcon />;
    }
  };

  const handleAction = (notificacao: Notificacao) => {
    if (!notificacao.lido) {
      marcarComoLida(notificacao.id);
    }

    switch (notificacao.tipo) {
      case 'racao':
        history.push('/producao/estoque');
        break;
      case 'parcela':
        history.push('/financeiro/movimentacao');
        break;
      default:
        if (notificacao.link_acao) {
          history.push(notificacao.link_acao);
        }
        break;
    }

    handleClose();
  };

  const buscarNotificacoes = async () => {
    try {
      if (store.propriedade) {
        const notificacoes = await NotificacaoService.buscarNotificacoes(store.propriedade.id);
        store.setNotificacoes(notificacoes);
        store.setNotificacoesNaoLidas(notificacoes.filter(n => !n.lido).length);
      }
    } catch (error) {
      console.error('Erro ao buscar notificações:', error);
    }
  };

  const marcarComoLida = async (id: number) => {
    try {
      await NotificacaoService.marcarComoLida(id, store.propriedade?.id || 0);
      await buscarNotificacoes();
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error);
    }
  };

  const marcarTodasComoLidas = async () => {
    try {
      if (store.propriedade) {
        await NotificacaoService.marcarTodasComoLidas(store.propriedade.id);
        await buscarNotificacoes();
        handleModalClose();
      }
    } catch (error) {
      console.error('Erro ao marcar todas notificações como lidas:', error);
    }
  };

  const renderNotificacao = (notificacao: Notificacao) => (
    <NotificacaoMenuItem
      key={notificacao.id}
      onClick={() => handleAction(notificacao)}
    >
      <div style={{ display: 'flex',width:'100%',justifyContent:'flex-end' }}>
        <CloseButton
          size="small"
          onClick={(e) => {
            e.stopPropagation();
            marcarComoLida(notificacao.id);
          }}
        >
          <CloseIcon fontSize="small" />
        </CloseButton>
      </div>


      <NotificacaoContent>
        <NotificacaoIconContainer>
          {getNotificationIcon(notificacao.tipo)}
        </NotificacaoIconContainer>
        <NotificacaoMessage>
          {notificacao.mensagem}
        </NotificacaoMessage>
      </NotificacaoContent>

    </NotificacaoMenuItem>
  );

  const sortedNotificacoes = [...store.notificacoes].sort(
    (a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
  );

  return (
    <>
      <IconButton color="inherit" onClick={handleClick}>
        <Badge badgeContent={store.notificacoesNaoLidas} color="error">
          <NotificationsIcon />
        </Badge>
      </IconButton>

      <Dialog
        open={modalOpen}
        onClose={handleModalClose}
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: '8px',
            overflow: 'hidden',
            paddingTop: '0px',
            
          }
        }}
      >
        <NotificacaoHeader>
          <NotificacaoTitle>Notificações</NotificacaoTitle>
          <HeaderCloseButton size="small" onClick={handleModalClose}>
            <CloseIcon />
          </HeaderCloseButton>
        </NotificacaoHeader>
        <DialogContent style={{ padding: 0 }}>
          <NotificacoesContainer>
            {sortedNotificacoes.length > 0 ? (
              <>
                {sortedNotificacoes.map(renderNotificacao)}
                {store.notificacoesNaoLidas > 0 && (
                  <div style={{ padding: '0 8px' }}>
                    <MarcarLidasButton onClick={marcarTodasComoLidas}>
                      Marcar todas como lidas
                    </MarcarLidasButton>
                  </div>
                )}
              </>
            ) : (
              <Typography style={{ padding: 16, textAlign: 'center', color: '#666' }}>
                Nenhuma notificação
              </Typography>
            )}
          </NotificacoesContainer>
        </DialogContent>
      </Dialog>

      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        PaperProps={{
          style: {
            maxHeight: '80vh',
            width: '450px',
            borderRadius: '8px',
            overflow: 'hidden',
            paddingTop: '0px',
          },
        }}
        MenuListProps={{
          style: {
            padding: 0
          }
        }}
      >
        <NotificacaoHeader>
          <NotificacaoTitle>Notificações</NotificacaoTitle>
          <HeaderCloseButton size="small" onClick={handleClose}>
            <CloseIcon />
          </HeaderCloseButton>
        </NotificacaoHeader>
        <MenuNotificacoesContainer>
          {sortedNotificacoes.length > 0 ? (
            <>
              {sortedNotificacoes.slice(0, 3).map(renderNotificacao)}
              {sortedNotificacoes.length > 3 && (
                <VerMaisButton
                  fullWidth
                  onClick={handleModalOpen}
                >
                  Veja mais avisos ({store.notificacoesNaoLidas} não lidos)
                </VerMaisButton>
              )}
            </>
          ) : (
            <Typography style={{ padding: 16, textAlign: 'center', color: '#666' }}>
              Nenhuma notificação
            </Typography>
          )}
        </MenuNotificacoesContainer>
      </Menu>
    </>
  );
};

export default observer(NotificacoesMenu); 